module.exports = __webpack_public_path__ + "img/successStory1.7080418a.jpg";